import { render, staticRenderFns } from "./TiposMovimentos.vue?vue&type=template&id=6d7aca4d&"
import script from "./TiposMovimentos.vue?vue&type=script&lang=js&"
export * from "./TiposMovimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports